//react
import React from "react";
import PropTypes from "prop-types";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux'

//firebase
import { db } from 'assets/firebase';

// react plugin for creating charts
import ChartistGraph from "react-chartist";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
//import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import School from "@material-ui/icons/LocationCityOutlined";
import Face from "@material-ui/icons/FaceOutlined";
//import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
//import LocalOffer from "@material-ui/icons/LocalOffer";
//import ArrowUpward from "@material-ui/icons/ArrowUpward";
//import AccessTime from "@material-ui/icons/AccessTime";
import ChatBubble from "@material-ui/icons/ChatBubbleOutline";
//import Cloud from "@material-ui/icons/Cloud";
import CreditCard from "@material-ui/icons/CreditCardOutlined"
import Teacher from "@material-ui/icons/AssignmentInd";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Tasks from "components/Tasks/Tasks.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
//import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import moment from 'moment';
import { bugs, website } from "variables/general";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

var Chartist = require("chartist");

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      purchases: [],
      students: [],
      last24Revenue: 0,
      countSchools: this.props.schools.length,
      countStudents: 0,
      countTeachers: this.props.teachers.length,
      visitsThisWeek: 0,
      videoViewsThisWeek: 0,
      siteVisits: {data: {labels: [], series:[] }, highValue: 20},
      lessonViews: {data: {labels: [], series:[] }, highValue: 50},
      worksheets: {data: {labels: [], series:[] }, highValue: 10},
      videoViews: {data: {labels: [], series:[] }, highValue: 10},
      studentActivity: [],
      classroomActivity: []
    };
  }

  componentDidMount() {

    if (this.props.user.authenticated) {

      // prepare dailySalesChart
      var dailySalesSeries = [];
      //dailySalesChart.data.labels = [];

      var days = moment().subtract(7,"days");
      for(var i = 1; i < 8; i++) {
        var day = days.add(1, "day");
        dailySalesChart.data.labels.push(day.format("D"));
        dailySalesSeries.push(0);
      }

      if(this.props.user.userType === 'admin') {
        
        // show everyone (temporarily scope it to the org)
        db.getActivityByOrg(this.props.user.orgId).then(activity => {

          db.getClasses().then(snapshot => {
            this.summarizeClassroomActivity(snapshot, activity);
          })

          this.summarizeActivityRecords(activity);

          db.getStudentsByOrg(this.props.org.id).then(snapshot => {
            this.setState({countStudents: snapshot.size})

            this.summarizeStudentActivity(snapshot, activity);
          });
        });

      } else if (this.props.user.userType === 'teacher') {
        
        db.getActivityByClass(this.props.user.classID).then(activity => {

          this.summarizeActivityRecords(activity);

          db.getStudentsByClass(this.props.user.classID).then(snapshot => {
            this.setState({countStudents: snapshot.size});
  
            this.summarizeStudentActivity(snapshot, activity);
          });
        });

      } else if (this.props.user.userType === 'principal') {
        
        db.getActivityBySchool(this.props.user.schoolID).then(activity => {
          this.summarizeActivityRecords(activity);

          db.getStudentsByOrg(this.props.org.id).then(snapshot => {
            this.setState({countStudents: snapshot.size});

            this.summarizeStudentActivity(snapshot, activity);
          });
        });
      }
    }
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  incrementArray(array, labels, date) {
    for(var i = 0; i < labels.length; i++) {
      if(labels[i].getMonth() === date.getMonth()
        && labels[i].getFullYear() === date.getFullYear()
        && labels[i].getDate() === date.getDate()
      ) {
        array[i] = array[i] + 1;
      }
    }
  }

  summarizeActivityRecords(records) {

    var labels = [];
    var dates = [];
    var siteVisits = [];
    var lessonViews = [];
    var worksheets = [];
    var videoViews = [];

    var oneWeekAgo = this.addDays(new Date(), -7).getTime();
    var totalVisits = 0;
    var totalVideoViews = 0;

    var today = Date();
    for(var h = 6; h > -1; h--) {
      var calculatedDate = this.addDays(today, -h);
      labels.push(calculatedDate.getMonth() + 1 + "/" + calculatedDate.getDate());
      dates.push(calculatedDate);

      siteVisits.push(0);
      lessonViews.push(0);
      worksheets.push(0);
      videoViews.push(0);
    }

    for(var i = 0; i < records.length; i++) {
      var ts = new Date(records[i].modified*1000);
      if((records[i].modified * 1000) > oneWeekAgo) {

        if(records[i].ActivityType === 'Lesson-Viewed') {
            this.incrementArray(lessonViews, dates, ts);
        
        } else if(records[i].ActivityType === 'Login-App') {
            this.incrementArray(siteVisits, dates, ts);
            totalVisits = totalVisits + 1;

        } else if(records[i].ActivityType === 'Worksheet-PDF-Created') {
            this.incrementArray(worksheets, dates, ts);

        } else if(records[i].ActivityType === 'Video-Played') {
            this.incrementArray(videoViews, dates, ts);
            totalVideoViews = totalVideoViews + 1;
        }
      }
    }

    this.setState({visitsThisWeek: totalVisits});
    this.setState({videoViewsThisWeek: totalVideoViews});

    var lessonViewsHigh = 0;
    for(var w = 0; w < lessonViews.length; w++)
      if(lessonViews[w] > lessonViewsHigh)
        lessonViewsHigh = lessonViews[w];

    var visitsHigh = 0;
    for(var y = 0; y < siteVisits.length; y++)
      if(siteVisits[y] > visitsHigh)
        visitsHigh = siteVisits[y];

    var worksheetsHigh = 0;
    for(var z = 0; z < worksheets.length; z++)
      if(worksheets[z] > worksheetsHigh)
        worksheetsHigh = worksheets[z];

    var videoViewsHigh = 0;
    for(var v = 0; v < videoViews.length; v++)
      if(videoViews[v] > videoViewsHigh)
        videoViewsHigh = videoViews[v];
      
            
    this.setState({siteVisits:          {data: { labels: labels, series: [siteVisits] }, highValue: visitsHigh * 1.1 }});
    this.setState({lessonViews:         {data: { labels: labels, series: [lessonViews] }, highValue: lessonViewsHigh * 1.1 }});
    this.setState({worksheets:          {data: { labels: labels, series: [worksheets] }, highValue: worksheetsHigh * 1.1 }});
    this.setState({videoViews:          {data: { labels: labels, series: [videoViews] }, highValue: videoViewsHigh * 1.1 }});
    
  }

  summarizeClassroomActivity(snapshot, activity) {

    var classrooms = [];
    snapshot.forEach((doc) => {
      var classroom = doc.data();
      classroom.id = doc.id;
      classroom.latestLogin = 0;
      classroom.worksheeetCount = 0;
      classroom.videoPlays = 0;

      for(var j = 0; j < activity.length; j++) {
        if(classroom.id === activity[j].ClassID) {
          
          if(activity[j].ActivityType === 'Login-App-Alt') {
            if(activity[j].modified > classroom.latestLogin) {
              classroom.latestLogin = activity[j].modified;
            }
          }
          else if(activity[j].ActivityType === 'Worksheet-PDF-Created' ) {
            classroom.worksheetCount = classroom.worksheetCount + 1;
          }
          else if(activity[j].ActivityType === 'Video-Played' ) {
            classroom.videoPlays = classroom.videoPlays + 1;
          }
        }
      }

      var latestLogin = "n/a";
      if((classroom.latestLogin) > 1542153600) // first day ids were handed out
        latestLogin = new Date(classroom.latestLogin * 1000).toDateString();

        classrooms.unshift([ classroom.Name, latestLogin, classroom.worksheeetCount.toString(), classroom.videoPlays.toString() ]);
    });

    this.setState({classroomActivity: classrooms});
  }

  summarizeStudentActivity(snapshot, activity) {

    var students = [];
    snapshot.forEach((doc) => {
      var student = doc.data();
      student.id = doc.id;
      student.latestLogin = 0;
      student.worksheeetCount = 0;
      student.videoPlays = 0;

      for(var j = 0; j < activity.length; j++) {
        if(student.id === activity[j].UserID) {
          
          if(activity[j].ActivityType === 'Login-App-Alt') {
            if(activity[j].modified > student.latestLogin) {
              student.latestLogin = activity[j].modified;
            }
          }
          else if(activity[j].ActivityType === 'Worksheet-PDF-Created' ) {
            student.worksheetCount = student.worksheetCount + 1;
          }
          else if(activity[j].ActivityType === 'Video-Played' ) {
            student.videoPlays = student.videoPlays + 1;
          }
        }
      }

      var latestLogin = "n/a";
      if((student.latestLogin) > 1542153600) // first day ids were handed out
        latestLogin = new Date(student.latestLogin * 1000).toDateString();

      students.unshift([ student.FirstName, student.LastName, latestLogin, student.worksheeetCount.toString(), student.videoPlays.toString() ]);
    });

    this.setState({studentActivity: students});
  }

  adminOnly() {
    if(this.props.user.userType === 'admin') 
      return "block";
    else
      return "none";
  }

  principalOnly() {
    if(this.props.user.userType === 'principal' || this.props.user.userType === 'admin') 
      return "block";
    else
      return "none";
  }
  
  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("teacher.hanyu.co/dashboard",["admin"],"Dashboard");

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={4} lg={4} style={{display:this.adminOnly()}}> 
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <School />
                </CardIcon>
                <p className={classes.cardCategory}>Schools</p>
                <h3 className={classes.cardTitle}>
                  {this.state.countSchools}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  2018-2019
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={4}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Face />
                </CardIcon>
                <p className={classes.cardCategory}>Students</p>
                <h3 className={classes.cardTitle}>
                  {this.state.countStudents}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  2018-2019
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={4} style={{display:this.principalOnly()}}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Teacher />
                </CardIcon>
                <p className={classes.cardCategory}>Teachers</p>
                <h3 className={classes.cardTitle}>{this.state.countTeachers}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  2018-2019
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="success">
                <ChartistGraph
                  className="ct-chart"
                  data={this.state.siteVisits.data}
                  type="Line"
                  options={{
                    lineSmooth: Chartist.Interpolation.cardinal({ tension: 0 }),
                    low: 0,
                    high: this.state.siteVisits.highValue, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0
                    }
                  }}
                  listener={dailySalesChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Daily Visitors</h4>
                <p className={classes.cardCategory}>
                  Last 7 Days: {this.state.visitsThisWeek} visits
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="danger">
                <ChartistGraph
                  className="ct-chart"
                  data={this.state.lessonViews.data}
                  type="Line"
                  options={{
                    lineSmooth: Chartist.Interpolation.cardinal({ tension: 0 }),
                    low: 0,
                    high: this.state.lessonViews.highValue, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0
                    }
                  }}
                  listener={completedTasksChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Daily Lesson Views</h4>
                <p className={classes.cardCategory}>
                  Number of lesson pages views made by students in your class.
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="info">
                <ChartistGraph
                  className="ct-chart"
                  data={this.state.worksheets.data}
                  type="Line"
                  options={{
                    lineSmooth: Chartist.Interpolation.cardinal({ tension: 0 }),
                    low: 0,
                    high: this.state.worksheets.highValue, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0
                    }
                  }}
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Worksheets Created</h4>
                <p className={classes.cardCategory}>
                  -
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="danger">
                <ChartistGraph
                  className="ct-chart"
                  data={this.state.videoViews.data}
                  type="Line"
                  options={{
                    lineSmooth: Chartist.Interpolation.cardinal({ tension: 0 }),
                    low: 0,
                    high: this.state.videoViews.highValue, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0
                    }
                  }}
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Video Plays</h4>
                <p className={classes.cardCategory}>
                Last 7 Days: {this.state.videoViewsThisWeek} views
                </p>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer >
          <GridItem xs={12} sm={12} md={6} style={{display:"none"}}>
            <CustomTabs
              title="Issues:"
              headerColor="primary"
              tabs={[
                {
                  tabName: "Chat",
                  tabIcon: ChatBubble,
                  tabContent: (
                    <Tasks
                      checkedIndexes={[0]}
                      tasksIndexes={[0, 1, 2, 3]}
                      tasks={bugs}
                    />
                  )
                },
                {
                  tabName: "Payment",
                  tabIcon: CreditCard,
                  tabContent: (
                    <Tasks
                      checkedIndexes={[0]}
                      tasksIndexes={[0, 1]}
                      tasks={website}
                    />
                  )
                }
              ]}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{display:this.principalOnly()}}>
            <Card>
              <CardHeader color="info">
                <h4 className={classes.cardTitleWhite}>Classroom Activity</h4>
                <p className={classes.cardCategoryWhite}>
                  
                </p>
              </CardHeader>
              <CardBody>
                <Table
                  tableHeaderColor="info"
                  tableHead={["Name", "Last Login", "Worksheets Printed", "Video Views"]}
                  tableData={this.state.classroomActivity}
                />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Student Activity</h4>
                <p className={classes.cardCategoryWhite}>
                  
                </p>
              </CardHeader>
              <CardBody>
                <Table
                  tableHeaderColor="success"
                  tableHead={["First", "Last Name", "Last Login", "Worksheets Printed", "Video Views"]}
                  tableData={this.state.studentActivity}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return state;
}

Dashboard = connect(mapStateToProps)(Dashboard);
export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx